import { DateTime, Settings } from 'luxon';
Settings.defaultLocale = 'en-US';
export var DateFormat;
(function (DateFormat) {
    DateFormat["Date"] = "date";
    DateFormat["DateTime"] = "date-time";
    DateFormat["DateMonth"] = "date-month";
    DateFormat["DateMonthDash"] = "date-month-dash";
    DateFormat["WeekNumber"] = "week-number";
    DateFormat["Month"] = "month";
})(DateFormat || (DateFormat = {}));
const defaultArgs = () => ({
    date: DateTime.utc().toJSDate(),
    format: DateFormat.DateMonth,
});
export const formatDate = (args) => {
    const { date, format } = { ...defaultArgs(), ...(args ?? {}) };
    const d = DateTime.fromJSDate(date);
    switch (true) {
        case format === DateFormat.Date: {
            return d.toISODate();
        }
        case format === DateFormat.DateTime: {
            return d.toFormat('DD t');
        }
        case format === DateFormat.DateMonth: {
            return d.toFormat('DD');
        }
        case format === DateFormat.DateMonthDash: {
            return d.toFormat('DD').replace(/\s/g, '-').replace(/,/g, '');
        }
        case format === DateFormat.WeekNumber: {
            return `Week ${d.weekNumber}`;
        }
        case format === DateFormat.Month: {
            return d.monthShort;
        }
    }
    return d.toISODate();
};
export const isoStringToDate = (value) => DateTime.fromISO(value).toJSDate();
export const isCurrentWeek = (weekNumber, year) => {
    const { weekNumber: currentWeekNumber, year: currentYear } = DateTime.now();
    return weekNumber === currentWeekNumber && year === currentYear;
};
export const isPreviousWeek = (weekNumber, year) => {
    const { weekNumber: previousWeekNumber, year: previousWeekYear } = DateTime.now().minus({ week: 1 }).endOf('week');
    return weekNumber === previousWeekNumber && year === previousWeekYear;
};
export const getLastWeek = () => {
    const { weekNumber, year } = DateTime.now().minus({ week: 1 }).endOf('week');
    return { weekNumber, year };
};
export const getDateRangeBounds = ({ startDate, endDate, weekRange, }) => {
    if (endDate <= startDate) {
        return {
            weekTo: startDate.weekNumber,
            yearTo: startDate.year,
            weekFrom: startDate.weekNumber,
            yearFrom: startDate.year,
        };
    }
    const today = DateTime.now();
    const duration = endDate.diff(startDate, ['weeks']);
    let weekFrom = startDate.weekNumber;
    let yearFrom = startDate.year;
    let weekTo = today.weekNumber;
    let yearTo = today.year;
    if (endDate.toISO() < today.toISO()) {
        weekTo = endDate.weekNumber;
        yearTo = endDate.year;
    }
    if (duration.weeks > weekRange) {
        const fromDate = DateTime.fromObject({
            weekNumber: weekTo,
            weekYear: yearTo,
        }).minus({ week: weekRange });
        yearFrom = fromDate.year;
        weekFrom = fromDate.weekNumber;
    }
    return {
        weekFrom,
        yearFrom,
        weekTo,
        yearTo,
    };
};
//# sourceMappingURL=dates.js.map